import { render } from "./support-message.vue?vue&type=template&id=f61c2418"
import script from "./support-message.vue?vue&type=script&lang=js"
export * from "./support-message.vue?vue&type=script&lang=js"
script.render = render

export default script